var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container skinc-container2"},[_c('TopSection'),_c('BottomCards')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }